import React, { useMemo } from 'react';
import PageTitle from 'common/components/PageTitle';

import { useNavigate } from 'react-router-dom';
import { templatesApi } from '../api/recommendation-templates';
import { ApiAdminV1RecommendationTemplateListApiArg } from '../../../../store/generated/admin/templates';
import { OrgRecommendationListTable } from './OrgRecommendationListTable';
import { RecommendationType } from 'common/constants/RecommendationType';

const OrganizationalGoalList = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = templatesApi.useApiAdminV1RecommendationTemplateListQuery({
    typeOf: RecommendationType.ORGANIZATIONAL_GOALS,
  } as ApiAdminV1RecommendationTemplateListApiArg);

  const [triggerDelete] = templatesApi.useApiAdminV1RecommendationTemplateDestroyMutation();

  const navigateToDetails = (projectId?: number) => {
    if (projectId) {
      navigate(`/settings/admin/recommendation-templates/org-goals/details/${projectId}`);
    } else {
      navigate(`/settings/admin/recommendation-templates/org-goals/details/create`);
    }
  };

  const handleItemDelete = (id: number) => {
    triggerDelete({ id });
  };

  const orgProjects = useMemo(() => {
    if (!data) return [];

    return data?.slice().sort((a, b) => a?.template?.title.localeCompare(b?.template?.title));
  }, [data]);

  return (
    <div data-testid="admin-org-goals-page">
      <OrgRecommendationListTable
        data-testid="admin-org-goals-table"
        title="Organizational Goal Templates"
        projects={orgProjects}
        isLoading={isLoading}
        error={error}
        onItemDeleteConfirm={handleItemDelete}
        onItemClick={navigateToDetails}
        onAddClick={() => navigateToDetails(undefined)}
      />
    </div>
  );
};

export default OrganizationalGoalList;
